import { HttpInterceptorFn } from '@angular/common/http';
import { clubConfig } from 'config/club.config';

export const subdomainInterceptor: HttpInterceptorFn = (request, next) => {
  const hostname = window.location.hostname;
    let subdomain = '';
    
    // Si l'hôte n'est pas simplement localhost ou une adresse IP
    if (!hostname.includes('localhost')  && !isIpAddress(hostname)) {
      // Extraction du sous-domaine
      const hostParts = hostname.split('.');
      
      // Si nous avons au moins 3 parties (ex: club.example.com), la première est le sous-domaine
      if (hostParts.length >= 3) {
        subdomain = hostParts[0];
      }
    }

    const subdomainClubConfig = clubConfig[0].subDomain.name;
     const isExternalApi =
        request.url.includes('nominatim.openstreetmap.org') ||
        request.url.includes('api-dofa.fff.fr') ||
        request.url.includes('restcountries.com') ||
        request.url.includes('openweathermap.org');
    
    // Si nous avons un sous-domaine, on l'ajoute aux en-têtes
    if (subdomain && !subdomain.includes('www') && !hostname.includes('localhost') && !isExternalApi) {
      // Clonage de la requête pour ajouter les nouveaux en-têtes
      const modifiedRequest = request.clone({
        setHeaders: {
          'X-Club-id': clubConfig[0].id,
          'X-original-Host': subdomainClubConfig
        }
      });
      
      return next(modifiedRequest);
    }
  return next(request);
};


// Fonction utilitaire pour vérifier si une chaîne est une adresse IP
function isIpAddress(hostname: string): boolean {
  // Regex simple pour vérifier si c'est une adresse IPv4
  const ipv4Pattern = /^(\d{1,3}\.){3}\d{1,3}$/;
  return ipv4Pattern.test(hostname);
}
